import React from 'react';
import ActiveMethodologies from './ActiveMethodologies';
import OpenActivity from './OpenActivity';
import ClosedExercise from './ClosedExercise';
import * as styles from './Activities.module.css';

export const Activities = ({ lesson, contentfulId, userId, isMobile }) => {
  const {
    childrenContentfulAulaActiveMethodologiesJsonNode: activeMethodologies,
  } = lesson;

  const activeMethodologiesWithoutLegacy = activeMethodologies?.filter(
    (activeMeth) => !!activeMeth?.activities?.[0]?.contextualization
  );

  const isBrowser = typeof window !== 'undefined';
  const passingSearch = isBrowser
    ? window.location.search.replace('?', '&')
    : '';
  const skipPhone =
    isBrowser && !!localStorage.getItem('phone_number')
      ? '&skipPhone=true'
      : '';
  const hasClosedExercise = !!(
    lesson.closedExercise?.childMarkdownRemark?.html ||
    lesson?.closedExerciseImages
  );
  const hasOpenActivity = !!(
    lesson?.exerciseText?.childMarkdownRemark?.html || lesson?.exerciseMedia
  );
  const totalActivities =
    activeMethodologiesWithoutLegacy?.length +
    Number(hasClosedExercise) +
    Number(hasOpenActivity);

  return (
    <section>
      <h2 className={styles.titleH2Activities}>
        Atividades ({totalActivities})
      </h2>
      <p className={styles.descriptionActivities}>
        Navegue ao lado nos tipo de atividade para visualizar as propostas para
        essa aula.
      </p>

      <ol className={styles.listContainer}>
        <ClosedExercise
          lesson={lesson}
          contentfulId={contentfulId}
          userId={userId}
          skipPhone={skipPhone}
          passingSearch={passingSearch}
          isMobile={isMobile}
        />

        <OpenActivity
          lesson={lesson}
          contentfulId={contentfulId}
          userId={userId}
          skipPhone={skipPhone}
          passingSearch={passingSearch}
          isMobile={isMobile}
        />

        <ActiveMethodologies
          activeMethodologies={activeMethodologiesWithoutLegacy}
          contentfulId={contentfulId}
          userId={userId}
          skipPhone={skipPhone}
          passingSearch={passingSearch}
          isMobile={isMobile}
          lesson={lesson}
        />
      </ol>
    </section>
  );
};
